

RequireLogin(() => InitializeUserDataView());

function InitializeUserDataView() {
    var hasCard = webUser.subscriptionType == CustomerAPI.PaymentType.Stripe && webUser.paymentCardNumber != null && webUser.paymentCardNumber.length > 0;
    $('#infoName').html(hasCard ? localizer["PaymentReplaceCardTitle"] : localizer["PaymentAddCardTitle"]);
    $('#savePaymentCardButton').html(hasCard ? localizer["PaymentReplaceCardButtonText"] : localizer["PaymentAddCardButtonText"]);
}

function StripePayment(token: string) {
    if (webUser.subscriptionType == CustomerAPI.PaymentType.None)
        CustomerAPI.subscriptionsAPI.stripeCreateCustomer(() => StripeChangeCard(token), StripeProblem);
    else
        StripeChangeCard(token);
}


function StripeChangeCard(token: string) {
    var form = $('#payment-form');
    CustomerAPI.subscriptionsAPI.stripeChangeCard(CustomerAPI.StripeCardData.fromJS({ token: token }),
        function () {
            form.find('.subscribe').html(localizer["StripeCardAdded"] + '<i class="fa fa-check"></i>');
            //CreateSubscriptionOnUnsubscribedDevices();
        },
        StripeProblem);
}

//function CreateSubscriptionOnUnsubscribedDevices()
//{
//    CustomerAPI.deviceAPI.get(devices =>
//    {
//        for (var device of devices) {
//            if (!device.hasSubscription)
//                CustomerAPI.subscriptionsAPI.stripeStartRecurring(device.imei);
//        }
//    });
//}

function StripeProblem() {
    var form = $('#payment-form');
    form.find('.subscribe').html(localizer["StripeProblemTitle"]).removeClass('success').addClass('error');
    /* Show Stripe errors on the form */
    form.find('.payment-errors').text(localizer["StripeProblemMessage"]);
    form.find('.payment-errors').closest('.row').show();
}